module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZBAMAAAA2x5hQAAAAMFBMVEVHcEz///////////////////////////////////////////////////////////9EPuwCAAAAD3RSTlMAcfbZwO0jMpwMGESJs1aMwL7MAAAA2klEQVQY00WQOwrCQBCG/2jwgc9bCDb2NtpaBYIg2GQRrLWzNOAB1BPoDcwNtLDXGwQLC7s8UCyUcXd2iVPs8M0/zMy/gI7e8MG5EKj37FFT5UnMxfL9qyRTBC59YEqkxMUe1Q/gESmx893DEUxSvDljHK7oSXrL1kqKfIRQks9DAivCWkvAzq9HOBKdmBp9STlKhL5JlAVqRCNkUSFK5n+UK15/WhpRN5TkwhZgx1krCTjGykxS29ZWgGKH6BlqK2CLHOYTQk2pnmN5TF2zc6vmppvsvpXrDoAfpI134YJoql0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/suspension/phone.png
// module id = blaG
// module chunks = 6